export default [
  {
    path: '/faturas',
    name: 'faturas',
    component: () => import(/* webpackChunkName: "faturas" */ '../../views/faturas/Faturas')
  },
  {
    path: '/faturas/:id',
    name: 'faturaDetalhes',
    component: () => import(/* webpackChunkName: "faturaDetalhes" */ '../../views/faturas/Detalhes')
  }
]
